import { spotlightTheme } from 'conversations-visitor-experience-components/visitor-widget/spotlight/theme';
import { useAppSelector } from '../buildStore';
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';
import { getSpotlightGlowColors } from '../widget-data/selectors/widgetDataSelectors';
export const useSpotlightGlowColor = () => {
  const {
    color,
    chatflowColor
  } = useAppSelector(getSpotlightGlowColors);
  if (getIsPortal53()) {
    return chatflowColor || spotlightTheme.color.orange;
  }
  return color;
};